import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faFile,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
} from '@fortawesome/pro-solid-svg-icons';
import {
  IMAGE_MIME_TYPE,
  MS_EXCEL_MIME_TYPE,
  MS_POWERPOINT_MIME_TYPE,
  MS_WORD_MIME_TYPE,
  PDF_MIME_TYPE,
} from '@mantine/dropzone';
import { matchesMimeType } from './helpers';

export const getFileIconDefinition = (
  fileType: string | null,
): IconDefinition => {
  const normalizedFileType = fileType?.toLowerCase() ?? null;

  if (matchesMimeType(normalizedFileType, IMAGE_MIME_TYPE)) {
    return faFileImage;
  }

  if (matchesMimeType(normalizedFileType, PDF_MIME_TYPE)) {
    return faFilePdf;
  }

  if (matchesMimeType(normalizedFileType, MS_WORD_MIME_TYPE)) {
    return faFileWord;
  }

  if (matchesMimeType(normalizedFileType, MS_EXCEL_MIME_TYPE)) {
    return faFileExcel;
  }

  if (matchesMimeType(normalizedFileType, MS_POWERPOINT_MIME_TYPE)) {
    return faFilePowerpoint;
  }

  return faFile;
};
